import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import {VisitorHistoryActionComponent, VisitorHistoryViewComponent} from "../../../../component/visit-application/visitor-history";
export default function VisitHistory(props) {
    const [ findVisitor, setFindVisitor ] = useState({name:'', phone:''});
    const [ visitorInfos, setVisitorInfos ] = useState<any>();

    function submit(e) {
        e.preventDefault();
        Api.findVisitor(findVisitor.name, findVisitor.phone).then(res => (
            (res.data) ? setVisitorInfos(res.data) : alert('조회결과가 없습니다.')
        ));
    }

    return (
        <div className={'nv_contents'}>
            <h2 className="nv_subtit">내방신청 이력조회</h2>
            <div className="History">
                <div className="nv_tablebox">
                    <div className="nv_table_tit">
                        <h2>방문자 정보</h2>
                    </div>
                    <form onSubmit={submit}>
                    <table className="nv_table" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <tr>
                                <td className="gray textcenter" >방문자</td>
                                <td>
                                    <div className="search_box">
                                        <input type="text"
                                               className="nv_input"
                                               onChange={(e) => setFindVisitor({...findVisitor, name : e.target.value})}
                                               required={true}
                                               placeholder="이름을 입력해주세요"/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="gray textcenter">연락처</td>
                                <td>
                                    <input type="number"
                                           className="nv_input"
                                           onChange={(e) => setFindVisitor({...findVisitor, phone : e.target.value})}
                                           required={true}
                                           placeholder="연락처를 입력해주세요"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="nv_btn_area">
                        <button type="submit" className="nv_btn_black">검색</button>
                    </div>
                    </form>
                </div>
                <div className="nv_tablebox">
                    {/*<div className="nv_table_tit">*/}
                    {/*    <h2>총 1건</h2>*/}
                    {/*</div>*/}
                    {
                        visitorInfos!==undefined &&
                            <VisitorHistoryViewComponent visitorInfo={visitorInfos}/>

                        // visitorInfos.map((row, index) =>
                        //     <VisitorHistoryComponent visitorInfo={visitorInfos}
                        //                              setVisitorInfo={setVisitorInfos()}/>)
                    }
                </div>
            </div>
        </div>
    )
}